import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers';
import { YesNoRendererComponent } from '../../../../../common/components/yes-no-renderer.component';

export default function selectEventsBookingModal({
  selectEvents
}: any) {

  return (
    <AccordionContainer
      child={
      <div className="max-w-[1200px] w-full mx-auto p-8 bg-gradient-to-br from-white via-rose-50 to-amber-50 border border-amber-200 rounded-2xl shadow-2xl text-gray-900 animate-fade-in">
          
          <h1 className="text-4xl font-extrabold text-center text-indigo-900 mb-6">
            {selectEvents?.Name || 'Unnamed selectEvents'}
          </h1>
          
          <div className="grid md:grid-cols-2 gap-6 text-lg mb-6">
            <div className="space-y-2">
              <p className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#0b1158" fill="none">
    <path d="M16 2V6M8 2V6" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M3 10H21" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <strong>Sale Start Date:</strong> {selectEvents?.SaleStartDate || '-'}</p>
              <p className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#0b1158" fill="none">
    <path d="M16 2V6M8 2V6" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M3 10H21" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M11.9955 14H12.0045M11.9955 18H12.0045M15.991 14H16M8 14H8.00897M8 18H8.00897" stroke="#0b1158" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <strong>Sale End Date:</strong> {selectEvents?.SaleEndDate || '-'}</p>
              <p className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#070925" fill="none">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C7.52232 2 3.77426 4.94289 2.5 9H5" stroke="#070925" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M12 8V12L14 14" stroke="#070925" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M2 12C2 12.3373 2.0152 12.6709 2.04494 13M9 22C8.6584 21.8876 8.32471 21.7564 8 21.6078M3.20939 17C3.01655 16.6284 2.84453 16.2433 2.69497 15.8462M4.83122 19.3065C5.1369 19.6358 5.46306 19.9441 5.80755 20.2292" stroke="#070925" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <strong>Duration:</strong> {selectEvents?.selectEventsDuration || '-'}</p>
            </div>

            <div className="space-y-2">
              <p className="flex items-center gap-2">
                <strong>Is Active:</strong>{' '}
                <YesNoRendererComponent value={selectEvents?.IsActive} />
              </p>
              <p className="flex items-center gap-2">
                 <strong>Includes Activities:</strong>{' '}
                <YesNoRendererComponent value={selectEvents?.IncludesActivities} />
              </p>
              <p className="flex items-center gap-2">
                 <strong>Price:</strong>{' '}
                 {selectEvents?.Price} 
              </p>
              
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold text-indigo-800 mb-2">selectEvents Description</h3>
            <p className="text-gray-800 bg-white p-4 rounded-md shadow-sm">
              {selectEvents?.Description || 'No description provided.'}
            </p>
          </div>
{(Array.isArray(selectEvents?.TermsAndConditions) && selectEvents.TermsAndConditions.length > 0) ||
(Array.isArray(selectEvents?.Benefits) && selectEvents.Benefits.length > 0) ? (
  <div className="flex justify-between gap-4 mb-6 flex-wrap md:flex-nowrap">

    {Array.isArray(selectEvents?.TermsAndConditions) && selectEvents.TermsAndConditions.length > 0 && (
      <div className="w-full md:w-1/2">
        <h3 className="text-xl font-semibold text-orange-700 mb-2">Terms and Conditions</h3>
        <div className="flex flex-wrap gap-2">
          {selectEvents.TermsAndConditions.map((terms: string, index: number) => (
            <span
              key={index}
              className="bg-white border border-orange-300 text-orange-700 px-3 py-1 rounded-full text-sm font-medium shadow-sm hover:bg-orange-100"
            >
              {terms}
            </span>
          ))}
        </div>
      </div>
    )}

    {Array.isArray(selectEvents?.Benefits) && selectEvents.Benefits.length > 0 && (
      <div className="w-full md:w-1/2">
        <h3 className="text-xl font-semibold text-rose-700 mb-2">Benefits</h3>
        <div className="flex flex-wrap gap-2">
          {selectEvents.Benefits.map((Benefit: string, index: number) => (
            <span
              key={index}
              className="bg-white border border-pink-300 text-rose-700 px-3 py-1 rounded-full text-sm font-medium shadow-sm hover:bg-pink-100"
            >
              {Benefit}
            </span>
          ))}
        </div>
      </div>
    )}

  </div>
) : null}



        </div>
      }
    />
  );
}
